import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useAuthStore } from "@/lib/auth/AuthStore";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import useDeviceType from "@/lib/web-ui/useDeviceType";
import { BRAND_HOME_PAGE } from "@/settings/constant";
import { Button } from "@bookips/solvook-ui-library";
import { Typography } from "@mui/material";
import { useRouter } from "next/router";
import { useCallback, useMemo, useState } from "react";
import useSnackbar, { IconWithSnackbarMessage, Snackbar, defaultSnackbarProps } from "../common/Snackbar";
import Icon from "../icon/Icon";
import { Copy_2px, Share, Sizes, Warning24FillRed } from "../icon/IconList";
import { useBrandStore } from "./BrandProvider";
const snackbarMessages = {
    success: /*#__PURE__*/ _jsxs(Typography, {
        variant: "subtitle1",
        sx: {
            display: "flex",
            alignItems: "center",
            gap: "8px",
            color: "#FFF"
        },
        children: [
            /*#__PURE__*/ _jsx(Icon, {
                icon: Copy_2px,
                size: Sizes.medium
            }),
            "URL이 복사됐어요."
        ]
    }),
    warning: /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs(Typography, {
            variant: "subtitle1",
            sx: {
                display: "flex",
                alignItems: "center",
                gap: "8px",
                color: "#FFF"
            },
            children: [
                /*#__PURE__*/ _jsx(Icon, {
                    icon: Warning24FillRed,
                    size: Sizes.medium
                }),
                "URL 복사에 실패했어요. 다시 시도해주세요."
            ]
        })
    })
};
export const ShareButton = ()=>{
    const { asPath , pathname  } = useRouter();
    const { user  } = useAuthStore();
    const name = useBrandStore((state)=>state.brand.name);
    const brandTitle = useBrandStore((state)=>state.brand.title);
    const nickname = useBrandStore((state)=>state.brand.nickname);
    const keyword = useBrandStore((state)=>state.brand.keyword);
    const { isShowSnackbar , showSnackbar , hideSnackbar  } = useSnackbar();
    const [messageType, setMessageType] = useState("success");
    const deviceType = useDeviceType();
    const referralCode = useMemo(()=>{
        if ("object" === "undefined") return;
        return user.id ? "".concat(window.location.origin).concat(BRAND_HOME_PAGE(name), "?referral=").concat(user.id) : "".concat(window.location.origin).concat(BRAND_HOME_PAGE(name), "?referral=");
    }, [
        user.id
    ]);
    const copyLink = useCallback(async (data)=>{
        await window.navigator.clipboard.writeText(data.url).then((res)=>{
            showSnackbar();
        });
    }, [
        showSnackbar
    ]);
    const onClickShare = useCallback(async ()=>{
        const data = {
            // title: nickname,
            // text: keyword,
            url: referralCode !== null && referralCode !== void 0 ? referralCode : ""
        };
        if (deviceType !== "desktop" && window.navigator.share) {
            try {
                await window.navigator.share(data);
            } catch (error) {
                ;
                setMessageType("warning");
                showSnackbar();
            }
        } else {
            setMessageType("success");
            copyLink(data);
        }
        //mx-242
        mixpanelEvent("Share Button Clicked", {
            Positon: "Brand Profile",
            "Button Name": "공유하기",
            "Brand Name": brandTitle
        });
    }, [
        deviceType,
        referralCode,
        nickname,
        keyword,
        showSnackbar,
        copyLink
    ]);
    return /*#__PURE__*/ _jsxs(Button, {
        onClick: onClickShare,
        variant: "strokeSecondary",
        style: {
            minWidth: "unset",
            width: "48px",
            height: "48px"
        },
        children: [
            /*#__PURE__*/ _jsx(Icon, {
                icon: Share,
                color: "#6A708A",
                size: Sizes.xmedium
            }),
            /*#__PURE__*/ _jsx(Snackbar, {
                ...defaultSnackbarProps,
                open: isShowSnackbar,
                onClose: hideSnackbar,
                message: /*#__PURE__*/ _jsx(IconWithSnackbarMessage, {
                    text: snackbarMessages[messageType]
                })
            })
        ]
    });
};
